import { Link, useLocation } from 'react-router-dom';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta({
    title: '页面未找到 - 神马影院',
    description: '抱歉，你访问的页面不存在或已被移动。返回神马影院首页，继续发现精彩影视内容。',
    keywords: '神马影院,页面不存在,404',
    path: location.pathname,
  });

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-[1400px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <p className="font-heading text-[100px] font-black leading-none text-background-300 md:text-[140px]">404</p>
      <h1 className="-mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或已被移动。回到首页，继续发现精彩的电影与电视剧内容吧。
      </p>
      <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-500"
        >
          <i className="ri-home-4-line"></i> 返回首页
        </Link>
        <Link
          to="/search"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-search-line"></i> 去搜索内容
        </Link>
      </div>
    </div>
  );
}